/* @ngInject */
function WarningMessageDialogController ($scope) {
  const api = {}
  this.getApi = () => api

  activate()
  function activate () {}

  $scope.closeModal = (onConfirm) => {
    $scope.returnData = {
      onConfirm: onConfirm
    }
    $scope.close($scope.returnData)
  }
}

export { WarningMessageDialogController }
